// extracted by mini-css-extract-plugin
export default {"page_title":"page_title__1Zo3X","file_input_desc":"file_input_desc__2Xc7L","detail":"detail__3RfXp","label":"label__T15Cp","value":"value__oBRGb","sort_able":"sort_able__3kbGD"};